import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Button,
  Paper,
  Divider,
} from "@mui/material";

export default function TermsMarksheetReceipt({ receiptData, school, setTemID }) {
  const [activities, setActivities] = useState([
    { name: "Formative Assessment-I" },
    { name: "Formative Assessment-II" },
    { name: "Final Exam" },
  ]);

  const totalGrade = [
    { name: "Semester" },
    { name: "Education" },
    { name: "Co-Curricular" },
    { name: "Total" },
    { name: "Special Remark" },
    { name: "C. Teacher Signature" },
  ];

  const totalActivity = [
    { name: "Qualities" },
    { name: "Creativity" },
    { name: "Regularity" },
    { name: "Punctuality" },
    { name: "Cleanness" },
    { name: "Cultural" },
    { name: "Discipline" },
    { name: "Confidence" },
    { name: "School Program" },
    { name: "School Mates " },
  ];

  // const student = markData[0]?.classRoom[0];
  const student = receiptData.data;

  const receiptId = `marksheet`;

  useEffect(() => {
    if (setTemID) {
      setTemID(receiptId);
    }
  }, [receiptData, setTemID, receiptId]);

  // extract unique subjects
  const subjects = useMemo(() => {
    const allMarks = student.flatMap((ms) => ms.marks);
    const unique = [...new Map(allMarks.map((m) => [m.subjectName.trim(), m])).values()];
    return unique.sort((a, b) =>
      a.subjectName.toLowerCase().localeCompare(b.subjectName.toLowerCase())
    );
  }, [student]);

  // quick lookup
  const findMark = (examType, subject) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    return term?.marks.find(
      (s) => s.subjectName.trim().toLowerCase() === subject.trim().toLowerCase()
    );
  };

  const getTotals = (examType) => {
    const term = student.find((m) => m.examType?.trim().toLowerCase()
    .includes(examType?.trim().toLowerCase()));
    if (!term) return { max: 0, obt: 0, grade: "-" };
    const max = term.marks.reduce((sum, s) => sum + (s.maxMark || 0), 0);
    const obt = term.marks.reduce((sum, s) => sum + (s.marksObtained || 0), 0);
    return { max, obt, grade: term.grade };
  };


  const addActivity = () => {
    const newName = `Activity-${activities.length + 1}`;
    setActivities([...activities, { name: newName }]);
  };

  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };

  const handlePrint = () => window.print();

  const [terms, setTerms] = useState([
    { n: "First" },
    { n: "Second" },
    { n: "Final" }
  ]);


  const t1 = getTotals("First");
  const t2 = getTotals("Second");
  const t3 = getTotals("Final");

  const cell1 = { border: "1px double #000", padding: "0px 2px" };

  return (
    <Box sx={{ background: "#fff", fontFamily: "Arial" }} id={receiptId} >
      <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", alignItems: "center", mb: 1, mt: 0 }}>
        <img
          src={school.logoUrl} // replace with your logo path
          alt="School Logo"
          style={{ width: 90, height: 80, marginTop: 1 }}
        />

        <Typography variant="h5" align="center" fontWeight="bold">
          {toCamelCase(school.schoolName)}
        </Typography>
        <Typography variant="subtitle2" align="center">
          {toCamelCase([school?.addressDTO.addressLine1, school?.addressDTO.city, school?.addressDTO.pincode, school?.addressDTO.state].join(", "))}
        </Typography>
        <Typography
          variant="subtitle2"
          align="center"
          sx={{ fontWeight: "bold", my: 1 }}
        >
          PROGRESS REPORT SESSION - {student[0]?.academicYear}
        </Typography>
      </Box>
      <Divider sx={{ mb: 1, mt: 1 }} />
      {/* Student Info */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography><strong>Student's Name: </strong> {toCamelCase(`${[student[0]?.name, student[0]?.father, student[0]?.last].filter(Boolean).join(" ")}`)}</Typography>
        <Typography><strong>Standard: </strong>{student[0]?.classRoom?.standard} | {student[0]?.classRoom?.section}</Typography>
        <Typography><strong>Roll No.: </strong> {student[0]?.classRoom?.id}</Typography>
      </Box>
      <Divider sx={{ m: 1 }} />
      {/* Marks Table */}
      <Box sx={{ py: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} rowSpan={2} align="center">
                <strong>Subject</strong>
              </TableCell>

              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                <strong>Term-I</strong>
              </TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                <strong>Term-II</strong>
              </TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} colSpan={4} align="center">
                <strong>Final Exam</strong>
              </TableCell>

              {/* <TableCell sx={{ border: "1px solid #000", padding: "8px" }}colSpan={activities.length} align="center">
                <strong>Co-Curricular Activity</strong>
              </TableCell> */}
            </TableRow>

            <TableRow>
              {[...Array(3)].flatMap(() => [
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Max</TableCell>,
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Min</TableCell>,
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Obt</TableCell>,
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">Grade</TableCell>,
              ])}
              {/* {activities.map((a, i) => (
                <TableCell sx={{ border: "1px solid #000", padding: "8px" }}key={i} align="center">
                  {a.name}
                </TableCell>
              ))} */}
            </TableRow>
          </TableHead>

          <TableBody>
            {subjects.map((sub, i) => {
              const term1 = findMark("First", sub.subjectName);
              const term2 = findMark("Second", sub.subjectName);
              const finalExam = findMark("Final", sub.subjectName);

              return (
                <TableRow key={i}>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }}>{toCamelCase(sub.subjectName)}</TableCell>

                  {/* Term-I */}
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.maxMark || 100}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.maxMark * 34 / 100 || 35}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.marksObtained || "-"}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term1?.grade || "-"}</TableCell>

                  {/* Term-II */}
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.maxMark || 100}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.maxMark * 34 / 100 || 35}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.marksObtained || "-"}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{term2?.grade || "-"}</TableCell>

                  {/* Final Exam */}
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.maxMark || 100}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.maxMark * 34 / 100 || 35}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.marksObtained || "-"}</TableCell>
                  <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{finalExam?.grade || "-"}</TableCell>

                  {/* Co-Curricular Activities */}
                  {/* {activities.map((_, j) => (
                    <TableCell sx={{ border: "1px solid #000", padding: "8px" }}align="center" key={j}>
                      <TextField
                        variant="standard"
                        placeholder="Very Good"
                        slotProps={{
                          input: {
                            disableUnderline: true,
                          },
                        }}
                      />
                    </TableCell>
                  ))} */}
                </TableRow>
              );
            })}

            {/* Totals Row */}
            <TableRow sx={{ background: "#f1f8e9" }}>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }}><strong>Total Marks</strong></TableCell>

              {/* Term-I */}
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.max}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.obt}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t1.grade}</TableCell>

              {/* Term-II */}
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.max}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.obt}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t2.grade}</TableCell>

              {/* Final Exam */}
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.max}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} />
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.obt}</TableCell>
              <TableCell sx={{ border: "1px solid #000", padding: "8px" }} align="center">{t3.grade}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>

      {/* Result Section */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography>Result: PASS</Typography>
        <Typography>Remarks: Excellent Performance</Typography>
        <Typography>Percentage: 87%</Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* Footer */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography>Class Teacher: ______________</Typography>
        <Typography>Head Master: ______________</Typography>
      </Box>
      <div class="pagebreak"></div>

      <Box sx={{ width: '100%', mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={cell1} colSpan={activities.length + 1} align="center">
                <strong>Co-Curricular Activity</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={cell1} align="center">{'#'}</TableCell>
              {activities.map((a, i) => (
                <TableCell sx={cell1} key={i} align="center">
                  {a.name}
                </TableCell>
              ))}

            </TableRow>
          </TableHead>

          <TableBody>
            {totalActivity.map((sub, i) => {
              return (
                <TableRow key={i}>
                  <TableCell sx={cell1}>{toCamelCase(sub.name)}</TableCell>
                  {activities.map((_, j) => (
                    <TableCell sx={cell1} align="center" key={j}>
                      <TextField
                        variant="standard"
                        placeholder="Very Good"
                        slotProps={{
                          input: {
                            disableUnderline: true,
                          },
                        }}
                          sx={{
                            "& input": {
                              fontFamily: "inherit",
                              fontSize: "14px",
                            },
                          }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={cell1} colSpan={totalGrade.length + 1} align="center">
                <strong>Total Grade</strong>
              </TableCell>
            </TableRow>

            <TableRow>
              {totalGrade.map((a, j) => (
                <TableCell sx={cell1} key={j} align="center">
                  {a.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {subjects.map((sub, i) => {
              return (
                <TableRow key={i}>
                  {i < 3 && totalGrade.map((_, j) => (
                    <TableCell
                      key={j}
                      sx={cell1}
                    //align="center"
                    >
                      {j === 0 ? (
                        terms[i]?.n || "-"
                      ) : (
                        <TextField
                          variant="standard"
                          placeholder=".........."
                          slotProps={{ input: { disableUnderline: true, }, }}
                        />
                      )}
                    </TableCell>
                  ))}

                </TableRow>
              );
            })}
          </TableBody>
        </Table>


        <TextField
          sx={{
            mt: 1,
            "& .MuiInputBase-input": {
              fontSize: "0.875rem", // as body2
            },
          }}
          variant="standard"
          placeholder="Very Good"
          slotProps={{
            input: { disableUnderline: true },
          }}
        />

        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "space-around", my: 2 }}>
          <Typography variant="body2">Class Teacher sign </Typography>
          <Typography variant="body2">Head Master </Typography>
        </Box>
      </Box>

      {/* <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button variant="contained" onClick={addActivity} sx={{ mr: 2 }}>
          + Add Activity Column
        </Button>
        <Button variant="outlined" color="success" onClick={handlePrint}>
          🖨️ Print Marksheet
        </Button>
      </Box> */}
    </Box>
  );
}